import { render, staticRenderFns } from "./ConsignStockByCustomertable.vue?vue&type=template&id=dcd86188&scoped=true&"
import script from "./ConsignStockByCustomertable.vue?vue&type=script&lang=js&"
export * from "./ConsignStockByCustomertable.vue?vue&type=script&lang=js&"
import style0 from "./ConsignStockByCustomertable.vue?vue&type=style&index=0&id=dcd86188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd86188",
  null
  
)

export default component.exports